export default __webpack_public_path__ + "static/media/nft2.99bdced7.png";